// 20220302144459
// https://api.github.com/users/aydansamedova

export default{
  "login": "aydansamedova",
  "id": 68549196,
  "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
  "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/aydansamedova",
  "html_url": "https://github.com/aydansamedova",
  "followers_url": "https://api.github.com/users/aydansamedova/followers",
  "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
  "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
  "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
  "repos_url": "https://api.github.com/users/aydansamedova/repos",
  "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
  "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
  "type": "User",
  "site_admin": false,
  "name": "Aydan Samedova",
  "company": null,
  "blog": "https://medium.com/@aydan2903",
  "location": "Baku, Azeribaijan",
  "email": null,
  "hireable": null,
  "bio": "#Frontend",
  "twitter_username": null,
  "public_repos": 22,
  "public_gists": 16,
  "followers": 61,
  "following": 18,
  "created_at": "2020-07-20T13:20:35Z",
  "updated_at": "2022-02-28T15:11:22Z"
}